<script>
export default {

  functional: true,
  props: {
    icon: {
      required: true,
      type: String,
    },
  },

  render(h, { data, props }) {
    return h('div', {
      attrs: data.attrs,
      staticClass: data.staticClass || 'inline-block',
      staticStyle: data.staticStyle,
      domProps: {
        // eslint-disable-next-line
        innerHTML: require(`!html-loader!../../assets/site/svg/${props.icon}.svg`),
      },
    });
  },
};
</script>
